import { MutationTree } from 'vuex';
import { State } from './detail.store';
import store from '@/store/index';

const mutations: MutationTree<State> = {
  setCurrentSubType(state: State, data: any) {
    state.currentSubType = data;
  },
  setWSMInstances(state: State, data: any) {
    state.wsmInstances = data;
  },
  setCurrentWSMInstance(state: State, data: any) {
    state.currentWSMInstance = data;
    store.commit('globalState/app/setUpdateDasboard', data, { root: true });
  }
};

export default mutations;
